import { format } from 'date-fns';
import { ChevronDownIcon } from 'lucide-react';
import { forwardRef, useState } from 'react';
import { Button } from '../Button/Button';
import { Calendar } from '../Calendar/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from '../Popover/Popover';
import { useModalStore } from '@/Domain/store/modal.store';

type DatePickerProps = {
  value: Date;
  onChange?: (value: Date | undefined) => void;
} & Omit<React.ComponentPropsWithoutRef<'button'>, 'value' | 'onChange'>;

const formatDate = (date: Date | undefined): string | undefined =>
  date ? format(date, 'yyyy-MM-dd') : undefined;
export const DatePicker = forwardRef<HTMLButtonElement, DatePickerProps>(
  ({ id, value, onChange }) => {
    const { open: isModalOpen } = useModalStore();
    const [open, setOpen] = useState(false);
    const [dateString, setDateString] = useState<string | undefined>(formatDate(value));

    return (
      <div className="flex flex-col gap-3">
        <Popover modal={isModalOpen} open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <Button variant="white" id={`date_${id}`} className="w-48 justify-between font-normal">
              {value ? dateString : 'Select date'}
              <ChevronDownIcon />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="w-auto overflow-hidden p-0" align="start">
            <Calendar
              mode="single"
              selected={value}
              captionLayout="dropdown"
              onSelect={(date) => {
                onChange?.(date);
                setDateString(formatDate(date));
                setOpen(false);
              }}
            />
          </PopoverContent>
        </Popover>
      </div>
    );
  },
);
